module.exports = __webpack_public_path__ + "img/buddha-bowl.f9779366.png";